import { uiSize } from '@utils'

interface Props {
  color?: string
  size?: number | string
}

function LayersIcon({ color = 'currentColor', size = 18 }: Props) {
  return (
    <svg
      width={uiSize(size)}
      height={uiSize(size)}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <path d='M12 3 3 8l9 5 9-5-9-5z' />
      <path d='m3 12.5 9 5 9-5' />
      <path d='m3 17 9 5 9-5' />
    </svg>
  )
}

export default LayersIcon
